import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/portfolio/Nav";
import { Hero } from "@/components/portfolio/Hero";
import { Marquee } from "@/components/portfolio/Marquee";
import { Reel } from "@/components/portfolio/Reel";
import { Animations } from "@/components/portfolio/Animations";
import { Criteria } from "@/components/portfolio/Criteria";
import { Process } from "@/components/portfolio/Process";
import { About } from "@/components/portfolio/About";
import { Contact } from "@/components/portfolio/Contact";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <div className="qva-root">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Reel />
        <Animations />
        <Criteria />
        <Process />
        <About />
      </main>
      <Contact />
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
